import * as React from "react";
import type { SVGProps } from "react";
const SvgNoSearchResults = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={91}
    height={63}
    fill="none"
    viewBox="0 0 91 63" {...props}
  >
    <path
      fill="url(#no-search-results_svg__a)"
      d="M87.142 12.411S80.12 32.471 70.52 41.806c-7.41 7.193-12.993 10.918-17.31 12.674.387-.022.644-.065.687-.086-.214.107-5.455 2.783-9.814 2.333-4.446-.47-6.315-1.627-21.069-8.156C8.28 42.04 4.522 34.569 4.522 34.569s-1.869-3.04-2.105-6.53c-.236-3.489 1.396-7.707 1.396-7.707S9.44 25.942 18.095 32c.515.364 1.052.728 1.632 1.092 3.823-2.312 9.278-6.166 14.046-11.582C42.192 11.94 46.4 4.94 46.4 4.94l40.72 7.471z"
      opacity={0.7}
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeDasharray="2.25 2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.633}
      d="M85.961 8.687s-2.964 8.456-7.667 16.934l-.58 1.027c-2.427 4.24-5.262 8.414-8.376 11.433-9.6 9.334-16.15 12.824-20.832 13.766S13.628 32.022 13.628 32.022s3.672-1.627 8.419-4.945c.43-.3.859-.621 1.31-.942 2.964-2.184 6.228-4.967 9.213-8.371 8.462-9.548 12.672-16.55 12.672-16.55z"
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.633}
      d="M3.34 30.844s3.737 7.472 18.492 14.001c14.754 6.53 16.622 7.707 21.068 8.157s9.836-2.334 9.836-2.334-6.314 1.157-9.363-3.96c-1.203-2.013-1.89-4.11-2.234-5.46a3.15 3.15 0 0 0-1.911-2.119c-4.124-1.541-15.335-5.973-22.293-10.854-6.056-4.24-10.61-8.243-12.822-10.276-2.212-2.034-1.847-.322-2.104.599-.43 1.541-.902 3.747-.774 5.716.237 3.49 2.105 6.53 2.105 6.53"
    />
    <path
      fill="#CBDEFF"
      stroke="#CBDEFF"
      strokeWidth={0.316}
      d="M50.777 6.715a6.1 6.1 0 0 1 3.729.044c1.198.407 2.242 1.215 2.758 2.442l.12.317c.527 1.59-.002 3.324-.818 4.686v.001c-.782 1.293-1.861 2.431-3 3.43l-.492.42c-.442.365-.904.711-1.364 1.04 1.39 1.102 3.026 1.955 4.632 2.633 6.785 2.9 14.298 4.118 21.641 3.67l.01-.002v.002c.15 0 .261.026.371.08l.197.098-.062.062c.137.173.172.41.124.615a.7.7 0 0 1-.639.552h-.292c-.88.064-1.74.086-2.62.086-3.921 0-7.842-.472-11.655-1.374h-.001a52 52 0 0 1-5.666-1.74c-1.679-.622-3.32-1.31-4.878-2.216v-.001a15 15 0 0 1-2.363-1.676c-2.024 1.262-4.19 2.255-6.414 3.1a87 87 0 0 1-9.81 3.11c-3.314.836-6.745 1.44-10.181 1.31a22 22 0 0 1-2.098-.172l-.41-.05.339-.237c.43-.3.853-.615 1.31-.94l.045-.033.056.004c.98.063 1.983.064 2.967.021l.604-.038c3.02-.223 6.003-.912 8.918-1.733 3.11-.877 6.197-1.86 9.174-3.098v-.001a32 32 0 0 0 4.471-2.243c-1.299-1.382-2.23-3.033-2.505-4.995l-.037-.291c-.158-1.457.04-2.963.742-4.28v-.002c.662-1.231 1.745-2.181 3.097-2.601Zm1.97 1.085c-1.031-.036-2.07.265-2.807.898V8.7c-1.034.876-1.53 2.137-1.62 3.473a7.5 7.5 0 0 0 .82 3.869l.12.232h-.016a8.7 8.7 0 0 0 1.407 1.86 20 20 0 0 0 2.385-1.899h.002c1.178-1.089 2.314-2.332 2.88-3.816.461-1.212.446-2.592-.459-3.515-.675-.693-1.68-1.067-2.712-1.103Z"
    />
    <path
      fill="#00217B"
      d="m76.797 48.926-2.26 2.042 9.204 10.574L86 59.5zM71.68 46.685l3.286 3.725 1.396-1.241-3.2-3.726z"
    />
    <path fill="#fff" d="M62.479 30.134c2.749-.664 5.798 0 8.053 1.734z" />
    <path
      stroke="#00217B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.633}
      d="M62.479 30.134c2.749-.664 5.798 0 8.053 1.734"
    />
    <circle
      cx={65}
      cy={38}
      r={10.5}
      fill="#CBDEFF"
      fillOpacity={0.5}
      stroke="#00217B"
    />
    <defs>
      <linearGradient
        id="no-search-results_svg__a"
        x1={2.395}
        x2={87.142}
        y1={30.866}
        y2={30.866}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgNoSearchResults;
